<script>
  export default {
    name: "error-mixin",
    methods: {
      showError(error) {
        this.$message({
          message: 'Oops, was unable to complete request \n Error: ' + error,
          center: true,
          duration: 6000,
          showClose: true,
          type: 'error'
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/mixins/errorMixin.vue